export enum ANALYTICS_EVENTS {
  VIEWED_HOMEPAGE = "Viewed_HomePage",
  VIEWED_CONVERSATION_DETAILS = "Viewed_ConversationDetailsPage",
  VIEWED_COACHING_TAB = "Viewed_CoachingTab",
  CLICKED_PUSH_TO_CRM = "Clicked_PushToCRM_FlowPanelPage",
  CREATED_WORKSPACE_CONNECTION = "Created_WorkspaceConnection",
  ERROR_WORKSPACE_CONNECTION = "Error_WorkspaceConnection",
  CREATED_CRM_CONNECTION = "Created_CRMConnection",
  CREATED_MEETING = "Created_Meeting",
  CREATED_CONVERSATION = "Created_Conversation",
  FILE_UPLOAD_STARTED = "File_Upload_Started",
  FILE_UPLOAD_INVALID_TYPE = "File_Upload_Invalid_Type",
  ATTACHMENT_UPLOAD_SUCCEEDED = "attachment_upload_succeeded",
  ATTACHMENT_UPLOAD_FAILED = "attachment_upload_failed",
  QUESTION_ATTACHMENTS_SKIPPED = "question_attachments_skipped",
  SPEAKER_PARTICIPANT_CHANGED = "Speaker_Participant_Changed",
  SEGMENT_SPEAKER_CHANGED = "Segment_Speaker_Changed",
  REPROCESSED_CONVERSATION = "Reprocessed_Conversation",
  INPERSON_RECORDING_STATE_CHANGED = "Inperson_RecordingStateChanged",

  // Conversation details page
  CONVERSATION_DETAILS_SUMMARY_TAB_CLICK = "conversation-details::summary-tab-click",
  CONVERSATION_DETAILS_COACHING_TAB_CLICK = "conversation-details::coaching-tab-click",
  CONVERSATION_DETAILS_ASK_FOCAL_TAB_CLICK = "conversation-details::ask-focal-tab-click",
  CONVERSATION_DETAILS_SPEAKER_ANALYTICS_TAB_CLICK = "conversation-details::speaker-analytics-tab-click",
  CONVERSATION_DETAILS_DATA_TAB_CLICK = "conversation-details::data-tab-click",
  CONVERSATION_DETAILS_REPROCESS_MENU_CLICK = "conversation-details::reprocess-menu-click",
  CONVERSATION_DETAILS_REPROCESS_MEETING_TYPE_CHANGED = "conversation-details::reprocess-meeting-type-changed",
  CONVERSATION_DETAILS_REPROCESS_SUBMIT = "conversation-details::reprocess-submit",
  CONVERSATION_DETAILS_ASK_FOCAL_MESSAGE_SUBMIT = "conversation-details::ask-focal-message-submit",
  CONVERSATION_DETAILS_ASK_ME_ANYTHING_CLICK = "conversation-details::ask-me-anything-click",
  CONVERSATION_DETAILS_PARTICIPANT_ADDED = "conversation-details::participant-added",
  CONVERSATION_DETAILS_PARTICIPANT_REMOVED = "conversation-details::participant-removed",
  CONVERSATION_DETAILS_PARTICIPANT_CREATED = "conversation-details::participant-created",
  CONVERSATION_DETAILS_TRANSCRIPT_LINE_SPEAKER_CHANGED = "conversation-details::transcript-line-speaker-changed",

  // Client details page
  CLIENT_DETAILS_ASK_FOCAL_MESSAGE_SUBMIT = "client-details::ask-focal-message-submit",
  CLIENT_DETAILS_ASK_ME_ANYTHING_CLICK = "client-details::ask-me-anything-click",

  // Meeting prep
  MEETING_PREP_ASK_ME_ANYTHING_CLICK = "meeting-prep::ask-me-anything-click",
  MEETING_PREP_EMAIL_EDITOR_OPEN_EMAIL_CLICK = "meeting-prep-email-editor::open-email-click",
  MEETING_PREP_EMAIL_EDITOR_COPY_PREMEETING_EMAIL_CLICK = "meeting-prep-email-editor::copy-premeeting-email-click",
  MEETING_PREP_LIST_ITEM_CLICK = "meeting-prep-list::meeting-prep-item-click",

  // Task manager
  TASK_CRM_FORM_PUSH_SUMMARY_TO_CRM_SUBMIT = "task-crm-form::push-summary-to-crm-submit",
  TASK_EMAIL_FORM_STATUS_CHANGED = "task-email-form::status-changed",
  TASK_EMAIL_FORM_SEND_FOLLOWUP_EMAIL_SUBMIT = "task-email-form::send-followup-email-submit",
  TASK_EMAIL_FORM_COPY_FOLLOWUP_EMAIL_CLICK = "task-email-form::copy-followup-email-click",
  TASK_FORM_PUSH_TASKS_TO_CRM_SUBMIT = "task-form::push-tasks-to-crm-submit",

  // App nav (Add meeting dropdown)
  APP_NAV_TRANSCRIBE_NAV_CLICK = "app-nav::transcribe-nav-click",
  APP_NAV_INVITE_NAV_CLICK = "app-nav::invite-nav-click",
  APP_NAV_UPLOAD_NAV_CLICK = "app-nav::upload-nav-click",

  // AI customization
  AI_CUSTOMIZATION_CUSTOM_SECTION_SAVED = "ai-customization::custom-section-saved",
  AI_CUSTOMIZATION_POST_PROCESSING_PROMPT_SAVED = "ai-customization::post-processing-prompt-saved",
}

export enum USER_PROPERTIES {
  WORKSPACE = "Workspace",
  CRM = "CRM",
}

// Type definitions
export type AnalyticsEvent =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
export type WorkspaceType = "Google Workspace" | "Microsoft Workspace";
export type MeetingCreationType =
  | "scheduled_from_calendar"
  | "adhoc_video_link";
